export default function HeroSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dramatic%20editorial%20composition%20with%20warm%20crimson%20and%20deep%20black%20gradients%2C%20subtle%20geometric%20patterns%20evoking%20entertainment%20news%20and%20gossip%20media%2C%20soft%20textured%20overlay%20with%20newsprint%20and%20digital%20elements%2C%20cinematic%20lighting%20with%20warm%20amber%20highlights%2C%20dark%20mysterious%20atmosphere%2C%20editorial%20photography%20style%2C%20no%20text%2C%20no%20recognizable%20faces%2C%20artistic%20abstract%20composition&width=1800&height=1200&seq=hero-bg-51cg-01&orientation=landscape"
          alt="51吃瓜黑料网 - 娱乐八卦资讯平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-0">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block text-xs md:text-sm font-medium text-accent-400 bg-accent-500/15 px-3 py-1 rounded-full mb-5 whitespace-nowrap">
              每日更新 · 吃瓜不停
            </span>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
              51吃瓜黑料网
              <br />
              <span className="text-accent-400">最全娱乐八卦在线入口</span>
            </h1>

            <p className="text-sm md:text-base text-accent-300 font-heading italic mb-6">
              吃瓜黑料入口一二三，随时随地畅享最新爆料
            </p>

            <p className="text-sm md:text-base text-background-200 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              51吃瓜黑料网是国内领先的娱乐八卦资讯聚合平台，覆盖明星动态、网红黑料、综艺内幕等多元内容。
              本站提供51吃瓜黑料网址直达与51吃瓜黑料入口一二三最新地址，确保您在任何时间、任何设备都能稳定访问。
              每日更新海量吃瓜内容，从热门事件到冷门爆料，一网打尽，吃瓜不迷路。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {[
                { value: '24h', label: '每日更新' },
                { value: '1000+', label: '爆料内容' },
                { value: '16+', label: '话题分类' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">
                    {stat.value}
                  </div>
                  <div className="text-xs text-background-300 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => handleScroll('#carousel')}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                立即吃瓜
              </button>
              <button
                onClick={() => handleScroll('#updates')}
                className="w-full sm:w-auto px-8 py-3 border border-background-300/40 text-background-100 font-medium text-sm rounded-md hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
              >
                最新爆料
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg hidden lg:block">
            <div className="relative">
              <div className="absolute -inset-4 bg-accent-500/10 rounded-2xl blur-xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20editorial%20still%20life%20composition%20with%20warm%20red%20and%20black%20tones%2C%20abstract%20shapes%20suggesting%20entertainment%20news%20and%20celebrity%20gossip%20themes%2C%20magazine%20cover%20aesthetic%20with%20bold%20geometric%20elements%2C%20cinematic%20dramatic%20lighting%2C%20luxurious%20dark%20atmosphere%20with%20warm%20accents%2C%20editorial%20photography%20style%2C%20no%20text%2C%20no%20recognizable%20people%2C%20sophisticated%20abstract%20visual&width=800&height=1000&seq=hero-visual-51cg-02&orientation=portrait"
                alt="51吃瓜黑料入口一二三 - 娱乐八卦每日更新"
                className="w-full rounded-lg object-cover"
                style={{ aspectRatio: '4/5' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}